<template>
  <ParagraphBody
    bodySize="small"
    :class="$style.login"
  >
    <span :class="$style.text">
      Already a JumpCloud customer?
    </span>
    <div :class="$style.buttonLink">
      <Link
        :class="$style.link"
        :href="login"
        isMatchText
        text="Log In"
        @click="eventTracking"
      />
    </div>
  </ParagraphBody>
</template>

<script>
import { Link, ParagraphBody } from '@jumpcloud/ui-components';
import { RouteGenerator } from 'client/util/Constants';
import EventHelper from 'client/GrowthEngineering/EventHelper';

const { login } = RouteGenerator;

export default {
  name: 'LoginLinkNew',

  components: {
    Link,
    ParagraphBody,
  },

  data() {
    return {
      login,
    };
  },

  methods: {
    eventTracking() {
      EventHelper.triggerSignupLoginLinkClicked();
    },
  },
};
</script>

<style module scoped>
.login {
  font-family: var(--sansSerifFont);
  text-align: right;
}

.buttonLink {
  color: var(--jc-button-informational);
  display: inline-block;
}

.link.link {
  font-size: var(--jcBodySmall);
}
</style>
